import { DecimalPipe, registerLocaleData } from '@angular/common';
import { HttpClient, provideHttpClient, withFetch } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  Injectable,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { provideClientHydration, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { SsrCookieService } from 'ngx-cookie-service-ssr';
import { routes } from './app.routes';
import { AppServices } from './shared/services';
import { WINDOW_PROVIDERS } from './shared/services/window/window.service';
import { ClientService } from './shared/services/client/client.service';
import { TranslateService } from './shared/services/translation/translate.service';
import { ClientStylesService } from './shared/services/client-styles/client-styles.service';
registerLocaleData(localeFr);
import { HammerModule, HammerGestureConfig } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

if (environment.production) {
  if (typeof window !== 'undefined') {
    window.console.log = () => { }
  }
}

@Injectable()
export class CustomHammerConfig extends HammerGestureConfig {
  override overrides = {
    swipe: { direction: 31 }, // Enable all swipe directions
    pinch: { enable: true }, // Enable pinch gestures
    rotate: { enable: false }, // Disable rotate
  };

  override options = {
    touchAction: 'pan-y', // ✅ Allow native vertical scrolling
  };
}

export function clientProviderFactory(provider: ClientService) {
  return () => provider.load();
}

export function translationsProviderFactory(provider: TranslateService) {
  return () => provider.load();
}

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom([
      BrowserAnimationsModule,
      AppServices,
      AngularSvgIconModule.forRoot(),
      HammerModule,
    ]),
    DecimalPipe,
    Title,
    SsrCookieService,
    ClientStylesService,
    {
      provide: MatDialogRef,
      useValue: {},
    },
    {
      provide: APP_INITIALIZER,
      useFactory: clientProviderFactory,
      deps: [ClientService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: translationsProviderFactory,
      deps: [TranslateService],
      multi: true,
    },
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    WINDOW_PROVIDERS,
    provideHttpClient(withFetch()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(),
    {
      provide: HammerGestureConfig,
      useClass: CustomHammerConfig,
    },
  ],
};
